module.exports = __webpack_public_path__ + "media/images/sec_3-7-8dc79caffaa0f3b61b328b99ba4922a5.png";